const BrandList = () => import('@/vuepage/catergory-manage/CatergoryList');

export default [
  {
    path: '/catergory-list',
    component: BrandList,
    meta: [
      {
        name: '分类管理'
      },
      {
        name: '分类列表',
        activeRoute: '/catergory-list'
      }
    ]
  }
]
